import React from "react";
import Navbar from "../navbar/navbar.js";
import "./firstSection.css";
import firstSectionImg from "../../assets/firstSectionImg.png";
import MintPotato from "./mintPotato/index.js";
const FirstSection = () => {
  return (
    <div className="firstSection-main-wrapper">
      <Navbar />
      <div className="banner-area">
        <div className="mint-potato-wraper">
          <MintPotato />
        </div>
        <img className="banner-image" src={firstSectionImg} alt="firstSectionImg" />
      </div>
    </div>
  );
};

export default FirstSection;
